import { InputAdornment, TextField } from '@mui/material';
import { TextFieldProps } from '@mui/material/TextField/TextField';
import React from 'react';

type PropsType = TextFieldProps;

export const PercentageField = (props: PropsType) => {
  const { slotProps, ...restProps } = props;

  const fieldProps: TextFieldProps = {
    slotProps: {
      ...slotProps,
      input: {
        inputMode: 'decimal',
        inputProps: {
          style: {
            textAlign: 'right',
          },
        },
        endAdornment: <InputAdornment position="end">%</InputAdornment>,
        ...slotProps?.input,
      },
    },
    ...restProps,
  };

  return <TextField {...fieldProps} />;
};
